module.exports = __webpack_public_path__ + "img/ironic_icon.ded41468.svg";